/**
 * Give an element an id that corresponds to an error key, to use this function
 * @param elementId
 */
export const scrollToError = (elementId?: string) => {
  if (!elementId) {
    return;
  }
  const elem = document.getElementById(elementId);

  if (elem) {
    elem.scrollIntoView({behavior: 'smooth'});
  }
};
